import { render } from "./support.vue?vue&type=template&id=20138e36&scoped=true"
const script = {}

import "./support.vue?vue&type=style&index=0&id=20138e36&lang=scss&scoped=true"

import exportComponent from "D:\\WorkJob\\SmartCarRace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20138e36"]])

export default __exports__